// src/api/catalog.ts
//
// Typed client for CRM-owned catalog upload/status endpoints.

import { getCrmServiceUrl } from '../utils/backend'
import { createApiClient } from './base'

const catalogClient = createApiClient(getCrmServiceUrl)

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export type CatalogFileRecord = {
  id?: string | null
  user_id?: string | null
  title?: string | null
  azure_blob_link?: string | null
  status?: string | null
  status_message?: string | null
  content?: string | null
  content_type?: string | null
  date_created?: string | null
  date_updated?: string | null
  ifDone?: boolean | null
  [key: string]: unknown
}

// ---------------------------------------------------------------------------
// Catalog extraction
// ---------------------------------------------------------------------------

/** Upload a catalog PDF for extraction. Uses FormData (no JSON body). */
export async function extractCatalog(
  userId: string,
  file: File,
): Promise<CatalogFileRecord> {
  const formData = new FormData()
  formData.append('user_id', userId)
  formData.append('file', file)
  return catalogClient.request<CatalogFileRecord>(
    '/catalog/create',
    { method: 'POST', rawBody: formData },
  )
}

/** Read the latest catalog extraction status for a user. */
export async function getCatalogStatus(userId: string): Promise<CatalogFileRecord> {
  return catalogClient.request<CatalogFileRecord>(
    `/catalog/${encodeURIComponent(userId)}/status`,
  )
}
